import {
  CanDeactivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from "@angular/router";
import { Location } from "@angular/common";
import { Injectable } from "@angular/core";
import Swal from 'sweetalert2';

@Injectable()
export class DeActivatedGuard implements CanDeactivate<any> {
  constructor(
    private readonly location: Location,
    private readonly router: Router
  ) {

  }

  canDeactivate(
    target: any,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): boolean {
    if (!target.mIsSubmitted) {
      const currentUrlTree = this.router.createUrlTree([], currentRoute);
      const currentUrl = currentUrlTree.toString();
      this.location.go(currentUrl);
      let msg = 'คุณแน่ใจว่าต้องการออกจากหน้านี้';
      // this.getAlertResult(msg);
      return window.confirm(msg);

    }
    return true;
  }

  getAlertResult(msg) {

    Swal.fire({
      title: 'คุณแน่ใจว่าต้องการออกจากหน้านี้',
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ใช่",
      cancelButtonText: "ไม่"
    }).then(result => {
      if (result.isConfirmed) {
        return true;
      } else {
        return false;
      }
    });


  }


}
